<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import GradeCartoes from '../componentes/GradeCartoes.svelte';
	import BarraPaginacao from '../componentes/BarraPaginacao.svelte';
	import CartaoQuadrado from '../componentes/cartoes/CartaoQuadrado.svelte';
	import {
		afirmacaoListagemDTO,
		apresentacaoSemanaGraduacaoListagemDTO,
		avaliacaoObjetoListagemAnonimizadaDTO,
		avaliacaoObjetoListagemDTO,
		bolsistaListagemDTO,
		grupoListagemDTO,
		listarObjetosAPI,
		projetoListagemDTO,
		TiposObjetosListagem,
		usuarioListagemDTO,
		verificarSeExisteCacheChaveLS,
		verificarSessionStorage
	} from '../utils';

	export let rotaErro = "/";
	export let chaveSSToken = "AVAL_TOKEN";
	export let chaveLSCache;
	export let endpointRecurso;
	export let tipoObjeto;
	export let parametros;
	export let componenteCartao = CartaoQuadrado;
	export let flexWrapFlagGrade = true;
	
	const dispatch = createEventDispatcher();
	let parseObjetos = [];
	let paginacaoComponente;

	onMount(async () => {
		if (verificarSessionStorage(chaveSSToken)) await carregarObjetosAPI(1);
		else replace(rotaErro);
	});

	const ajustarListagemObjetos = (listaObjetos) => {
		let objetoPushCallback;

		switch (tipoObjeto) {
			case TiposObjetosListagem.PROJETO:
				objetoPushCallback = projetoListagemDTO;
				break;
			case TiposObjetosListagem.APRESENTACAO_SEMGRAD:
				objetoPushCallback = apresentacaoSemanaGraduacaoListagemDTO;
				break;
			case TiposObjetosListagem.AVALIACAO:
				objetoPushCallback = avaliacaoObjetoListagemDTO;
				break;
			case TiposObjetosListagem.AVALIACAO_ANON:
				objetoPushCallback = avaliacaoObjetoListagemAnonimizadaDTO;
				break;
			case TiposObjetosListagem.AFIRMACAO:
				objetoPushCallback = afirmacaoListagemDTO;
				break;
			case TiposObjetosListagem.BOLSISTA:
				objetoPushCallback = bolsistaListagemDTO;
				break;
			case TiposObjetosListagem.GRUPO:
				objetoPushCallback = grupoListagemDTO;
				break;	
			default:
				objetoPushCallback = usuarioListagemDTO;
				break;
		}
		
		listaObjetos.forEach( objeto => parseObjetos.push(objetoPushCallback(objeto)));
	}

	const callbackCarregarObjetos = async (pagina) => {
		if (verificarSeExisteCacheChaveLS(pagina, chaveLSCache)) carregarObjetosCache(pagina);
		else await carregarObjetosAPI(pagina);
	}
	
	const carregarObjetosCache = (pagina) => {
		let { dados, paginacao } = JSON.parse(localStorage.getItem(chaveLSCache + pagina));

		// limpa o array
		parseObjetos = [];
		
		paginacaoComponente = paginacao;
		ajustarListagemObjetos(dados);
		
		// espalha os objetos no array
		parseObjetos = [...parseObjetos];
	}

	const carregarObjetosAPI = async (pagina) => {
		// limpa o array
		parseObjetos = [];
		
		const { dados, paginacao } = await listarObjetosAPI(`${endpointRecurso}?page=${pagina}`, dispatch, replace, rotaErro);
		paginacaoComponente = paginacao;
		ajustarListagemObjetos(dados);
		// console.log(dados);
		// espalha os objetos no array
		parseObjetos = [...parseObjetos];
		
		// armazena no cache
		localStorage.setItem(chaveLSCache + paginacaoComponente.paginaAtual, JSON.stringify({
			dados: dados,
			paginacao: paginacaoComponente
		}));
	}
</script>

<BarraPaginacao callback={callbackCarregarObjetos} { ... paginacaoComponente }/>

<GradeCartoes itens={parseObjetos} componente={componenteCartao} flexWrap={flexWrapFlagGrade} parametros={parametros} />
